import { render, staticRenderFns } from "./ArticleQualityHistory.vue?vue&type=template&id=00b0cbf3"
import script from "./ArticleQualityHistory.vue?vue&type=script&lang=js"
export * from "./ArticleQualityHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports